import { configureStore } from "@reduxjs/toolkit";

import {
  MyProjectReducer,
  OrganizationSliceReducer,
  OrganizationUserSliceReducer,
  MyProfileSliceReducer,
  DifficultyLevelReducer,
  CourseLevelReducer,
  ProficiencyLevelReducer,
  EvaluationMethodReducer,
  AssessmentStatusReducer,
  AssessmentTemplateTypeReducer,
  AssessmentMethodReducer,
  QuestionCategoryReducer,
  SkillCategoryReducer,
  SkillGroupReducer,
  SkillReducer,
  SkillProficiencyLevelReducer,
  SkillAreaReducer,
  EvaluationCriteriaReducer,
  QuestionBankReducer,
  PrepareAssessmentReducer,
  CompetencyFrameworkReducer,
  SkillMappingReducer,
  QuestionTypeReducer,
  SkillAssessmentReducer,
  PublishAssessmentReducer,
  SkillAssessmentAssessorReducer,
  MapAssessorReducer,
  AssessmentResponseReducer,
  GapAnalysisReducer,
  ProjectUsersReducer,
  CompetencyFrameworkStatusReducer,
  ResponseStatusReducer,
  SkillAssessmentStatusReducer,
  TalenaiseDashboardSliceReducer,
  IndustryReducer,
  DomainReducer,
  ProgrammingLanguageReducer
} from "@slice";

export const store = configureStore({
  reducer: {
    industry: IndustryReducer,
    domain: DomainReducer,
    myProject: MyProjectReducer,
    organization: OrganizationSliceReducer,
    organizationUsers: OrganizationUserSliceReducer,
    myProfile: MyProfileSliceReducer,
    difficultyLevel: DifficultyLevelReducer,
    courseLevel: CourseLevelReducer,
    proficiencyLevel: ProficiencyLevelReducer,
    evaluationMethod: EvaluationMethodReducer,
    assessmentTemplateType: AssessmentTemplateTypeReducer,
    assessmentMethod: AssessmentMethodReducer,
    questionCategory: QuestionCategoryReducer,
    skillCategory: SkillCategoryReducer,
    skillGroup: SkillGroupReducer,
    skill: SkillReducer,
    skillProficiencyLevel: SkillProficiencyLevelReducer,
    skillArea: SkillAreaReducer,
    evaluationCriteria: EvaluationCriteriaReducer,
    questionBank: QuestionBankReducer,
    prepareAssessment: PrepareAssessmentReducer,
    competencyFramework: CompetencyFrameworkReducer,
    skillMapping: SkillMappingReducer,
    questionType: QuestionTypeReducer,
    
    skillAssessment: SkillAssessmentReducer,
    publishAssessment: PublishAssessmentReducer,
    skillAssessmentAssessor: SkillAssessmentAssessorReducer,
    mapAssessors: MapAssessorReducer,
    assessmentResponse: AssessmentResponseReducer,
    gapAnalysis: GapAnalysisReducer,
    projectUsers: ProjectUsersReducer,
    assessmentStatus: AssessmentStatusReducer,

    competencyFrameworkStatus: CompetencyFrameworkStatusReducer,
    responseStatus: ResponseStatusReducer,
    skillAssessmentStatus: SkillAssessmentStatusReducer,

    talenaiseDashboard: TalenaiseDashboardSliceReducer,
    programmingLanguage: ProgrammingLanguageReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
